<template>
  <div class="c-movieImage thumbnail">
    <vuetube
      class="c-serviceImage_videoInner"
      :video-id="movie.providerSiteMovieId"
      :is-active.sync="isVideoActive"
      :padding-type="paddingType"
      :padding-ratio="paddingRatio"
      :width="boxWidth"
      :height="boxHeight"
      :is-modal="isModal"
      ref="vuetube"
    />
  </div>
</template>
<script>
import Vuetube from '~/components/molecules/Vuetube'

export default {
  name: 'MovieWrap',
  components: {
    Vuetube
  },
  data() {
    return {
      isVideoActive: false
    }
  },
  props: {
    movie: {
      type: Object,
      default: () => {}
    },
    boxWidth: {
      type: [Number, String],
      default: 'auto'
    },
    boxHeight: {
      type: [Number, String],
      default: 'auto'
    },
    paddingType: {
      type: String,
      default: 'ratio'
    },
    paddingRatio: {
      type: [Number, String],
      default: 100
    },
    isModal: {
      type: Boolean,
      default: false
    }
  }
}
</script>
